import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import { GetUserProfile } from "../../service/action-creators/authAction";
import Loader from "../Loader";

// Loan routes require a profile picture. The check runs on the route rather than
// on the buttons that link here so that typing the URL directly is also covered.
function ProfileImageRoute({ component: Component, children, ...rest }) {
  const dispatch = useDispatch();
  const token = window.localStorage.getItem("token");
  const user = useSelector((state) => state?.auth?.user);
  const isLoading = useSelector((state) => state?.auth?.isLoading);
  const fetchAttempted = useRef(false);

  const profileLoaded = Boolean(user?._id);

  useEffect(() => {
    if (token && !profileLoaded) {
      fetchAttempted.current = true;
      dispatch(GetUserProfile());
    }
  }, [dispatch, token, profileLoaded]);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!token) {
          return <Redirect to="/" />;
        }

        // auth.user starts as {} and is not persisted, so wait for the fetch
        // instead of treating an unloaded profile as a missing picture. If the
        // fetch finished without a profile, fall through to /profile rather
        // than holding the spinner forever.
        if (!profileLoaded && (isLoading || !fetchAttempted.current)) {
          return <Loader />;
        }

        if (!user?.profile_image) {
          return (
            <Redirect
              to={{
                pathname: "/profile",
                state: { requireProfileImage: true, from: props.location?.pathname },
              }}
            />
          );
        }

        return Component ? <Component {...props} /> : children;
      }}
    />
  );
}

export default ProfileImageRoute;
